<template>
    <div>
        <v-list>
            <v-list-item v-for="item in items" :key="item.title" @click="() => {}">
                <v-list-item-avatar color="blue" v-if="item.type !== 'tag'">
                    <v-img :src="item.avatar" v-if="item.avatar"></v-img>
                    <span v-else>{{item.title[0]}}</span>
                </v-list-item-avatar>
                <v-list-item-avatar v-else color="grey">
                    <span class="headline white--text">#</span>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>
<script>
export default {
    data: () => ({
        items: [
            { type: 'tag', title: '#Hoi', avatar: '' },
            { type: 'tag', title: '#Hai', avatar: '' }
        ]
    }),
}
</script>